export const h1 = {
  fontSize: 'var(--seed-semantic-typography-h1-font-size)',
  fontWeight: 'var(--seed-semantic-typography-h1-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-h1-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-h1-letter-spacing)',
};

export const h2 = {
  fontSize: 'var(--seed-semantic-typography-h2-font-size)',
  fontWeight: 'var(--seed-semantic-typography-h2-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-h2-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-h2-letter-spacing)',
};

export const h3 = {
  fontSize: 'var(--seed-semantic-typography-h3-font-size)',
  fontWeight: 'var(--seed-semantic-typography-h3-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-h3-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-h3-letter-spacing)',
};

export const h4 = {
  fontSize: 'var(--seed-semantic-typography-h4-font-size)',
  fontWeight: 'var(--seed-semantic-typography-h4-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-h4-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-h4-letter-spacing)',
};

export const title1Bold = {
  fontSize: 'var(--seed-semantic-typography-title1-bold-font-size)',
  fontWeight: 'var(--seed-semantic-typography-title1-bold-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-title1-bold-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-title1-bold-letter-spacing)',
};

export const title1Regular = {
  fontSize: 'var(--seed-semantic-typography-title1-regular-font-size)',
  fontWeight: 'var(--seed-semantic-typography-title1-regular-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-title1-regular-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-title1-regular-letter-spacing)',
};

export const title2Bold = {
  fontSize: 'var(--seed-semantic-typography-title2-bold-font-size)',
  fontWeight: 'var(--seed-semantic-typography-title2-bold-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-title2-bold-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-title2-bold-letter-spacing)',
};

export const title2Regular = {
  fontSize: 'var(--seed-semantic-typography-title2-regular-font-size)',
  fontWeight: 'var(--seed-semantic-typography-title2-regular-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-title2-regular-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-title2-regular-letter-spacing)',
};

export const title3Bold = {
  fontSize: 'var(--seed-semantic-typography-title3-bold-font-size)',
  fontWeight: 'var(--seed-semantic-typography-title3-bold-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-title3-bold-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-title3-bold-letter-spacing)',
};

export const title3Regular = {
  fontSize: 'var(--seed-semantic-typography-title3-regular-font-size)',
  fontWeight: 'var(--seed-semantic-typography-title3-regular-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-title3-regular-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-title3-regular-letter-spacing)',
};

export const subtitle1Bold = {
  fontSize: 'var(--seed-semantic-typography-subtitle1-bold-font-size)',
  fontWeight: 'var(--seed-semantic-typography-subtitle1-bold-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-subtitle1-bold-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-subtitle1-bold-letter-spacing)',
};

export const subtitle1Regular = {
  fontSize: 'var(--seed-semantic-typography-subtitle1-regular-font-size)',
  fontWeight: 'var(--seed-semantic-typography-subtitle1-regular-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-subtitle1-regular-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-subtitle1-regular-letter-spacing)',
};

export const subtitle2Bold = {
  fontSize: 'var(--seed-semantic-typography-subtitle2-bold-font-size)',
  fontWeight: 'var(--seed-semantic-typography-subtitle2-bold-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-subtitle2-bold-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-subtitle2-bold-letter-spacing)',
};

export const subtitle2Regular = {
  fontSize: 'var(--seed-semantic-typography-subtitle2-regular-font-size)',
  fontWeight: 'var(--seed-semantic-typography-subtitle2-regular-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-subtitle2-regular-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-subtitle2-regular-letter-spacing)',
};

export const bodyL1Bold = {
  fontSize: 'var(--seed-semantic-typography-body-l1-bold-font-size)',
  fontWeight: 'var(--seed-semantic-typography-body-l1-bold-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-body-l1-bold-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-body-l1-bold-letter-spacing)',
};

export const bodyL1Regular = {
  fontSize: 'var(--seed-semantic-typography-body-l1-regular-font-size)',
  fontWeight: 'var(--seed-semantic-typography-body-l1-regular-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-body-l1-regular-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-body-l1-regular-letter-spacing)',
};

export const bodyL2Bold = {
  fontSize: 'var(--seed-semantic-typography-body-l2-bold-font-size)',
  fontWeight: 'var(--seed-semantic-typography-body-l2-bold-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-body-l2-bold-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-body-l2-bold-letter-spacing)',
};

export const bodyL2Regular = {
  fontSize: 'var(--seed-semantic-typography-body-l2-regular-font-size)',
  fontWeight: 'var(--seed-semantic-typography-body-l2-regular-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-body-l2-regular-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-body-l2-regular-letter-spacing)',
};

export const bodyM1Bold = {
  fontSize: 'var(--seed-semantic-typography-body-m1-bold-font-size)',
  fontWeight: 'var(--seed-semantic-typography-body-m1-bold-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-body-m1-bold-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-body-m1-bold-letter-spacing)',
};

export const bodyM1Regular = {
  fontSize: 'var(--seed-semantic-typography-body-m1-regular-font-size)',
  fontWeight: 'var(--seed-semantic-typography-body-m1-regular-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-body-m1-regular-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-body-m1-regular-letter-spacing)',
};

export const bodyM2Bold = {
  fontSize: 'var(--seed-semantic-typography-body-m2-bold-font-size)',
  fontWeight: 'var(--seed-semantic-typography-body-m2-bold-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-body-m2-bold-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-body-m2-bold-letter-spacing)',
};

export const bodyM2Regular = {
  fontSize: 'var(--seed-semantic-typography-body-m2-regular-font-size)',
  fontWeight: 'var(--seed-semantic-typography-body-m2-regular-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-body-m2-regular-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-body-m2-regular-letter-spacing)',
};

export const caption1Bold = {
  fontSize: 'var(--seed-semantic-typography-caption1-bold-font-size)',
  fontWeight: 'var(--seed-semantic-typography-caption1-bold-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-caption1-bold-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-caption1-bold-letter-spacing)',
};

export const caption1Regular = {
  fontSize: 'var(--seed-semantic-typography-caption1-regular-font-size)',
  fontWeight: 'var(--seed-semantic-typography-caption1-regular-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-caption1-regular-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-caption1-regular-letter-spacing)',
};

export const caption2Bold = {
  fontSize: 'var(--seed-semantic-typography-caption2-bold-font-size)',
  fontWeight: 'var(--seed-semantic-typography-caption2-bold-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-caption2-bold-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-caption2-bold-letter-spacing)',
};

export const caption2Regular = {
  fontSize: 'var(--seed-semantic-typography-caption2-regular-font-size)',
  fontWeight: 'var(--seed-semantic-typography-caption2-regular-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-caption2-regular-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-caption2-regular-letter-spacing)',
};

export const label1Bold = {
  fontSize: 'var(--seed-semantic-typography-label1-bold-font-size)',
  fontWeight: 'var(--seed-semantic-typography-label1-bold-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-label1-bold-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-label1-bold-letter-spacing)',
};

export const label1Regular = {
  fontSize: 'var(--seed-semantic-typography-label1-regular-font-size)',
  fontWeight: 'var(--seed-semantic-typography-label1-regular-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-label1-regular-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-label1-regular-letter-spacing)',
};

export const label2Bold = {
  fontSize: 'var(--seed-semantic-typography-label2-bold-font-size)',
  fontWeight: 'var(--seed-semantic-typography-label2-bold-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-label2-bold-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-label2-bold-letter-spacing)',
};

export const label2Regular = {
  fontSize: 'var(--seed-semantic-typography-label2-regular-font-size)',
  fontWeight: 'var(--seed-semantic-typography-label2-regular-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-label2-regular-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-label2-regular-letter-spacing)',
};

export const label3Bold = {
  fontSize: 'var(--seed-semantic-typography-label3-bold-font-size)',
  fontWeight: 'var(--seed-semantic-typography-label3-bold-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-label3-bold-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-label3-bold-letter-spacing)',
};

export const label3Regular = {
  fontSize: 'var(--seed-semantic-typography-label3-regular-font-size)',
  fontWeight: 'var(--seed-semantic-typography-label3-regular-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-label3-regular-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-label3-regular-letter-spacing)',
};

export const label4Bold = {
  fontSize: 'var(--seed-semantic-typography-label4-bold-font-size)',
  fontWeight: 'var(--seed-semantic-typography-label4-bold-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-label4-bold-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-label4-bold-letter-spacing)',
};

export const label4Regular = {
  fontSize: 'var(--seed-semantic-typography-label4-regular-font-size)',
  fontWeight: 'var(--seed-semantic-typography-label4-regular-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-label4-regular-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-label4-regular-letter-spacing)',
};

export const label5Bold = {
  fontSize: 'var(--seed-semantic-typography-label5-bold-font-size)',
  fontWeight: 'var(--seed-semantic-typography-label5-bold-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-label5-bold-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-label5-bold-letter-spacing)',
};

export const label5Regular = {
  fontSize: 'var(--seed-semantic-typography-label5-regular-font-size)',
  fontWeight: 'var(--seed-semantic-typography-label5-regular-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-label5-regular-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-label5-regular-letter-spacing)',
};

export const label6Bold = {
  fontSize: 'var(--seed-semantic-typography-label6-bold-font-size)',
  fontWeight: 'var(--seed-semantic-typography-label6-bold-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-label6-bold-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-label6-bold-letter-spacing)',
};

export const label6Regular = {
  fontSize: 'var(--seed-semantic-typography-label6-regular-font-size)',
  fontWeight: 'var(--seed-semantic-typography-label6-regular-font-weight)',
  lineHeight: 'var(--seed-semantic-typography-label6-regular-line-height)',
  letterSpacing: 'var(--seed-semantic-typography-label6-regular-letter-spacing)',
};